import { types } from "mobx-state-tree";

import { createCustomReadonlyDictionary } from "stores/templates/ReadonlyDictionaryStore";
import api from "services/api";
import { MSURL } from "utils/ms";
import { PUBLISH_STATUSES } from "constants/models";

const pathClaim = "/nutrition/api/v1";
export const ClaimDictionaryItem = types.model({
  id: types.number,
  title: types.string,
});

const ClaimDictionary = createCustomReadonlyDictionary({
  itemModel: ClaimDictionaryItem,
  fetch: async function() {
    const response = await api.get(
      `${pathClaim}/claim`,
      { publishStatus: PUBLISH_STATUSES.PUBLISHED },
      undefined,
      MSURL,
    );
    return { items: response.items };
  },
  getValue: value => value,
  getLabel: ({ title }) => title,
});

export default ClaimDictionary.create();
